import React from 'react';
import styles from './App.module.css';
import Navigation from './components/Navigation/Navigation';
import Hero from './components/Hero/Hero';
import AboutUs from './components/AboutUs/AboutUs';
import Solution from './components/Solution/Solution';
import Pricing from './components/Pricing/Pricing';
import Location from './components/Location/Location';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className={styles.app}>
      <Navigation />
      <main>
        <Hero />
        <AboutUs />
        <Solution />
        <Pricing />
        <Location />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;